import React, { useState } from 'react';
import { Table, Link, Box, StatusIndicator, SpaceBetween } from '@amzn/awsui-components-console';
import { ProfilesTableProps, Profile, TableSortingState } from '../../types';

const ProfilesTable: React.FC<ProfilesTableProps> = ({ 
    profiles, 
    loading, 
    onSelectionChange, 
    onSortingChange,
    onProfileSelect 
}) => {
    const [sortingState, setSortingState] = useState<TableSortingState>({
        sortingColumn: {
            sortingField: 'lastUpdated',
            sortingDescending: true
        }
    });

    const handleSortingChange = (event: any) => {
        const newSortingState = {
            sortingColumn: event.detail.sortingColumn
        };
        setSortingState(newSortingState);
        onSortingChange(newSortingState);
    };

    const formatDate = (dateString: string) => {
        const date = new Date(dateString);
        // Format as YYYY-MM-DD HH:MM
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}`;
    };



    const columnDefinitions = [
        {
            id: 'name',
            header: 'Profile Name',
            cell: (item: Profile) => (
                <Link 
                    href="#" 
                    external={false}
                    fontSize="body-m"
                    onFollow={(e) => {
                        e.preventDefault();
                        onProfileSelect?.(item.id);
                    }}
                >
                    {item.name}
                </Link>
            ),
            sortingField: 'name',
            isRowHeader: true,
            width: 300
        },
        {
            id: 'createdBy',
            header: 'Created by',
            cell: (item: Profile) => (
                <Link 
                    href={`#user/${item.createdBy}`} 
                    external={true}
                    fontSize="body-m"
                >
                    {item.createdBy}
                </Link>
            ),
            sortingField: 'createdBy',
            width: 200
        },
        {
            id: 'lastUpdated',
            header: 'Last Updated',
            cell: (item: Profile) => (
                <Box fontSize="body-m">
                    {formatDate(item.lastUpdated)}
                </Box>
            ),
            sortingField: 'lastUpdated',
            width: 200
        }
    ];

    return (
        <Table
            columnDefinitions={columnDefinitions}
            items={profiles}
            loading={loading}
            loadingText="Loading profiles"
            sortingColumn={sortingState.sortingColumn}
            onSortingChange={handleSortingChange}
            trackBy="id"
            variant="container"
            stickyHeader={true}
            stripedRows={true}
            empty={
                <Box 
                    textAlign="center" 
                    padding={{ vertical: 'xl' }}
                    color="text-status-inactive"
                >
                    <SpaceBetween size="m">
                        <Box variant="p" color="inherit">
                            No profiles found
                        </Box>
                        <Box variant="p" color="inherit">
                            Create your first profile to get started
                        </Box>
                    </SpaceBetween>
                </Box>
            }
        />
    );
};

export default ProfilesTable;